import { render, staticRenderFns } from "./friendsBandstaff.vue?vue&type=template&id=7d04885d&scoped=true"
import script from "./friendsBandstaff.vue?vue&type=script&lang=js"
export * from "./friendsBandstaff.vue?vue&type=script&lang=js"
import style0 from "./friendsBandstaff.vue?vue&type=style&index=0&id=7d04885d&prod&scoped=true&lang=css"
import style1 from "./friendsBandstaff.vue?vue&type=style&index=1&id=7d04885d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d04885d",
  null
  
)

export default component.exports